import { createTheme } from '@mui/material/styles';
import { useMemo, useState } from 'react';

export type ColorMode = 'light' | 'dark';

function useColorMode() {
    const [mode, setMode] = useState<ColorMode>('light');
    const setColorMode = useMemo(
        () => ({
            toggleColorMode: (color: ColorMode) => {
                if (color !== null) {
                    setMode(color);
                }
            },
        }),
        [],
    );

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                },
            }),
        [mode],
    );

    return { theme, mode, setColorMode };
}

export default useColorMode;
